<template>
    <ui-crud title="Equipment"
             :subtitle="packageReference?'Current and historical plant usage for Package.':'Log plant usage and site allocations.'"
             :fetch="fetch" :pipe-with="pipeItems"
             :group-by="groupByLetters">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
            <div class="pt-2 px-0 flex justify-start space-x-2">
                <ui-button-new :small="true" :primary="!limitToAssigned" @click="applyLimit(false)">All</ui-button-new>
                <ui-button-new :small="true" :primary="limitToAssigned" @click="applyLimit(true)">Currently On-Site</ui-button-new>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="item.name"
                :subtitle="[item.inUseBy ? item.inUseBy : 'In Warehouse', item.inUseAt ? item.inUseAt : null]"
                :metadata="item.reference"
                :active="active"
                @click="select()"
                @keydown.enter="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <assets-equipment-form :add-item="addItem" :equipment="equipment" v-if="equipment"></assets-equipment-form>
            <div v-else>
                <div
                    class="z-30 absolute inset-0 bg-white bg-opacity-95 flex flex-col justify-center items-center mx-4 my-8 text-gray-500 space-y-3">
                    <svg class="animate-spin text-gray-400 w-10 h-10" xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <p class="text-xl">Loading...</p>
                </div>
            </div>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <assets-equipment-form :item="selectedItem" :edit="setEditMode"></assets-equipment-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <assets-equipment-show :item="selectedItem" :edit="setEditMode"
                                   :removeItem="removeItem"></assets-equipment-show>
        </template>
    </ui-crud>
</template>

<script>
import {sortBy} from 'lodash'
import {Equipment} from '@models'

export default {
    props: {
        packageReference: null,
    },
    data() {
        return {
            search: '',
            equipment: false,
            limitToAssigned: false,
        }
    },
    methods: {
        applyLimit(apply) {
            this.limitToAssigned = apply
        },
        async fetch() {
            if (!this.equipment) {
                if (this.packageReference) {
                    this.equipment = sortBy(await Equipment.byPackageReference(this.packageReference), item => item.name.trim())
                } else {
                    this.equipment = sortBy(await Equipment.all(), item => item.name.trim())
                }
            }
            return this.equipment;
        },
        groupByLetters(item) {
            const name = item.name.trim()
            const letter = (name[0] || '0').toUpperCase()
            return isNaN(letter) ? letter : '#';
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let retItems = items.filter((i) => {
                return !this.limitToAssigned || (i.inUse && (!this.packageReference || (i.inUseAt === this.packageReference)))
            })
            if (query.length) {
                return retItems.filter((i) => {
                    return query.every((token) => {
                        return i.tokens.includes(token);
                    })
                });
            }
            return retItems;
        },
    },
}
</script>
